import axios from 'axios';

const readNotificationsApi = async (values, token, langIsoCode) => {
  try {
    const res = await axios.post('/Auth_private/readNotification', values, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + token,
        lang: langIsoCode
      }
    });
    return res;
  } catch (error) {
    throw error;
  }
};

export default readNotificationsApi;
